
import React from 'react';
import { Story } from '@/utils/storiesData';
import StoryCard from '@/components/story/StoryCard';
import { useTheme } from '@/contexts/ThemeContext';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface BrowseGridProps {
  stories: Story[];
}

const BrowseGrid: React.FC<BrowseGridProps> = ({ stories }) => {
  const { resolvedTheme } = useTheme();
  const isMobile = useIsMobile();
  
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-black';
  const mutedTextColor = resolvedTheme === 'dark' ? 'text-white/70' : 'text-black/70';

  if (stories.length === 0) {
    return (
      <div className={cn("text-center py-16", mutedTextColor)}>
        <p>No stories found in this category.</p>
      </div>
    );
  }

  return (
    <div className="max-w-screen-2xl mx-auto">
      <div className={cn(
        isMobile 
          ? "grid grid-cols-1 gap-6" 
          : "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-6 lg:gap-8"
      )}>
        {stories.map((story) => (
          <StoryCard 
            key={story.id} 
            story={story} 
            featured={false} 
            aspectRatio={isMobile ? "16/9" : "21/9"}
            disableAnimation={true}
            hideAuthor={true}
            useBrowseMobileStyle={isMobile && window.location.pathname.includes('/browse')}
          />
        ))}
      </div>
    </div>
  );
};

export default BrowseGrid;
